var map = {
	"./0.png": 1242,
	"./1.png": 6451,
	"./10.png": 2171,
	"./10_gk.png": 3110,
	"./11.png": 7346,
	"./11_gk.png": 1921,
	"./12.png": 1961,
	"./12_gk.png": 5996,
	"./13.png": 3840,
	"./13_gk.png": 2879,
	"./14.png": 5167,
	"./14_gk.png": 6162,
	"./15.png": 8230,
	"./15_gk.png": 141,
	"./16.png": 2205,
	"./16_gk.png": 5784,
	"./17.png": 8308,
	"./17_gk.png": 5131,
	"./18.png": 2179,
	"./18_gk.png": 1438,
	"./19.png": 4426,
	"./19_gk.png": 4681,
	"./1_gk.png": 1902,
	"./2.png": 696,
	"./20.png": 298,
	"./20_gk.png": 2089,
	"./2_gk.png": 3975,
	"./3.png": 1825,
	"./3_gk.png": 4324,
	"./4.png": 4110,
	"./4_gk.png": 6933,
	"./5.png": 9687,
	"./5_gk.png": 3962,
	"./6.png": 1580,
	"./6_gk.png": 4035,
	"./7.png": 4469,
	"./7_gk.png": 8192,
	"./8.png": 9938,
	"./8_gk.png": 7057,
	"./9.png": 1067,
	"./9_gk.png": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8227;